var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonesvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.797 10.7545L13.4174 11.1318C13.4174 11.1318 12.5152 12.0289 10.0527 9.58034C7.59026 7.13185 8.49241 6.23482 8.49241 6.23482L8.73141 5.99716C9.32024 5.41171 9.37574 4.47177 8.86199 3.78558L7.81121 2.38191C7.17539 1.53261 5.94679 1.42042 5.21804 2.14504L3.91004 3.44561C3.54869 3.80491 3.30654 4.27067 3.3359 4.78735C3.41103 6.1092 4.00909 8.95326 7.34629 12.2715C10.8852 15.7903 14.2058 15.9302 15.5637 15.8036C15.9932 15.7636 16.3667 15.5448 16.6677 15.2455L17.8516 14.0685C18.6507 13.2739 18.4253 11.9118 17.4029 11.356L15.8108 10.4905C15.1395 10.1256 14.3217 10.2328 13.797 10.7545Z",
    fill: "#5F6D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonesvg);
export default __webpack_public_path__ + "static/media/phonesvg.f42e2cdd0fa05af2431d5ba524b4007f.svg";
export { ForwardRef as ReactComponent };